import {
  AutoCategoryTile
} from '@autos/auto-results/components/auto-category-slide/entities/auto-category-tile';
import { AutoInfo } from '@autos/auto-results/entities/auto-info';
import { VehicleOption, VehicleOptionDetailValidate } from '@autos/entities/vehicle';
import { ReservationVehicle } from '@user-history/entities/history-booking-detail';

export function mapTileCarInfo(tile: AutoCategoryTile): AutoInfo {
  return {
    passengers: tile.passengers,
    doors: tile.doors,
    baggage: tile.baggage,
    transmission: tile.transmission
  } as AutoInfo;
}

export function mapAutoCarInfo(auto: VehicleOption | VehicleOptionDetailValidate | ReservationVehicle): AutoInfo {
  const baggage = [];
  if (auto?.Vehicle?.SmallLuggage) baggage.push(auto.Vehicle.SmallLuggage);
  if (auto?.Vehicle?.NormalLuggage) baggage.push(auto.Vehicle.NormalLuggage);
  if (auto?.Vehicle?.LargeLuggage) baggage.push(auto.Vehicle.LargeLuggage);

  const rateDescription = () => {
    if ('RateDescription' in auto) {
      return auto?.RateDescription;
    } else if ('Rates' in auto) {
      return auto?.Rates ? auto.Rates[0]?.RateDescription : null;
    } 
  };

  return {
    passengers: `${auto.Vehicle?.MaxPax}`,
    doors: `${auto.Vehicle?.Doors}`,
    baggage: baggage.join(' | '),
    transmission: `${auto.Vehicle?.TransmissionType}`,
    air_conditioned: auto.Vehicle?.AirConditioned,
    vehicle: auto,
    rateDescription: rateDescription()
  } as AutoInfo;
}
